import ConsumerTabsPanel from './ConsumerTabsPanel';

export default ConsumerTabsPanel;
